import React from 'react';
import './App.css';
// import axios from 'axios';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';

import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';

import { AboutPage } from './pages/AboutPage';
import { GamesPage } from './pages/GamesPage.jsx'
import { HomePage } from './pages/HomePage.jsx'
import { Login } from './pages/Login.jsx'
import { ProfilePage } from './pages/ProfilePage.jsx'
import { NewsPage } from './pages/NewsPage.jsx'
import { TeamsPage } from './pages/TeamsPage';
import { SignupPage } from './pages/SignupPage.jsx'
import { WordleGame } from './components/Wordle';
import { ManiaPage } from './pages/ManiaPage';
import { NotFoundPage } from './pages/NotFoundPage';
import { NonogramGame } from './components/Nonogram';
import { ClompyClickerGame } from './components/ClompyClicker';
import { LeaderboardPage } from './pages/LeaderboardPage';
import { CardsPage } from './pages/CardsPage';
import { GameLeaderboardsPage } from './pages/GameLeaderboardsPage';
import { AdminPage } from './pages/AdminPage';
import { LinkPage } from './pages/LinkPage';

// React functional component
function App () {

  return (
    <div className="App-dark">
      <Router>
        <Switch>
          <Route exact path="/" component={HomePage}/>
          <Route exact path="/about" component={AboutPage} />
          <Route exact path="/games" component={GamesPage} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/home" component={HomePage} />
          <Route exact path="/profile" component={ProfilePage} />
          <Route exact path="/profile/:id" component={ProfilePage} />
          {/* the cards page showing one player's collection; the key makes it start fresh when coming from /cards */}
          <Route key="player-cards" exact path="/profile/:who/cards" component={CardsPage} />
          <Route exact path="/news" component={NewsPage} />
          <Route exact path="/cards" component={CardsPage} />
          <Route exact path="/leaderboard" component={GameLeaderboardsPage} />
          <Route exact path="/link" component={LinkPage} />
          <Route exact path="/admin" component={AdminPage} />
          <Route exact path="/admin/users" component={AdminPage} />
          <Route exact path="/teams" component={TeamsPage} />
          <Route exact path="/register" component={SignupPage} />
          <Route exact path="/wordle" component={WordleGame} />
          <Route exact path="/mania" component={ManiaPage} />
          <Route exact path="/nonogram" component={NonogramGame} />
          <Route exact path="/clompyclicker" component={ClompyClickerGame} />
          <Route exact path="/:game/leaderboard" component={LeaderboardPage} />
          <Route exact path='*' component={NotFoundPage} />
        </Switch>
      </Router>
    </div>
  );
}

export default App;
